module.exports = __webpack_public_path__ + "static/media/icon-dropdown.45611a2a.svg";